import React from "react"
import ContentLoader from "react-content-loader"

export default function MenuItemLoadingPlaceholder() {
  return (
    <ContentLoader viewBox="0 0 400 100" rtl={true}>
      <rect x="0" y="20" rx="5" ry="5" width="400" height="60"/>
    </ContentLoader>
  )
}
